/**
 * Formats a number with fixed decimal places and strips trailing zeros.
 * e.g. 1.00 -> "1", 1.50 -> "1.5", 1.23 -> "1.23"
 */
export function formatNumber(value: number, decimals = 2): string {
  const s = value.toFixed(decimals)
  return s.replace(/\.?0+$/, "")
}

export function formatPercent(decimal: number, decimals = 0): string {
  return `${(decimal * 100).toFixed(decimals)}%`
}

const MAX_PERCENT_TICK_DECIMALS = 10

/**
 * Axis tick label. Keeps up to two decimals, or two significant digits for
 * smaller magnitudes, so neighbouring fractional ticks stay distinct. Below
 * what ten decimals can show, the two significant digits use exponent form.
 */
export function formatPercentTick(decimal: number): string {
  const percent = decimal * 100
  if (percent === 0 || !Number.isFinite(percent)) {
    return `${formatNumber(percent)}%`
  }
  const decimals = Math.max(2, 1 - Math.floor(Math.log10(Math.abs(percent))))
  if (decimals > MAX_PERCENT_TICK_DECIMALS) {
    return `${Number(percent.toPrecision(2))}%`
  }
  return `${formatNumber(percent, decimals)}%`
}

export function formatCompactNumber(n: number): string {
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1)}M`
  }
  if (n >= 1_000) {
    return `${(n / 1_000).toFixed(1)}K`
  }
  return n.toLocaleString()
}
